import {API} from 'aws-amplify';

// @ts-ignore
export const create = async (post) => API.put('robinhoodEngUserApi', `/likes/${post.id}`, {});

// @ts-ignore
export const del = async (post) => API.del('robinhoodEngUserApi', `/likes/${post.id}`, {});
